<script setup lang="ts">
import Header from "./components/Header.vue";
import Hero from "./components/Hero.vue";
import Features from "./components/Features.vue";
import About from "./components/About.vue";
import FAQ from "./components/FAQ.vue";
import Footer from "./components/Footer.vue";
import { useSectionTracking } from "./composables/useSectionTracking";
import { useScrollTracking } from "./composables/useScrollTracking";

// Initialize section tracking
useSectionTracking();

// Initialize scroll tracking
useScrollTracking();
</script>

<template>
  <div class="min-h-screen bg-black">
    <Header />
    <Hero />
    <Features />
    <About />
    <FAQ />
    <Footer />
  </div>
</template>
